export default "__VITE_ASSET__DhvZ0wA9__"